/* Country Road Fashions — the product photographs (Shiva, 2026-09-28).

   The viewer is a plain scroll container and the rail is plain anchors, so
   everything here is a refinement: the current thumb follows the frame in
   view, hovering a thumb shows its frame, the scroll hint goes at the last
   frame, the phone counter reads "2 / 4", and the stage learns the header's
   height so it is exactly one screen tall. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.crfGalleryInit) return;
    root.dataset.crfGalleryInit = '1';

    var viewer = root.querySelector('[data-crf-viewer]');
    if (!viewer) return;
    var frames = Array.prototype.slice.call(viewer.querySelectorAll('[data-crf-frame]'));
    var rail = root.querySelector('[data-crf-rail]');
    var thumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('a')) : [];
    var hint = root.querySelector('[data-crf-hint]');
    var countNow = root.querySelector('[data-crf-count-now]');
    var live = root.querySelector('[data-crf-live]');
    var railLabel = rail ? rail.getAttribute('aria-label') : '';
    var current = -1;
    var ticking = false;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function horizontal() {
      return getComputedStyle(viewer).scrollSnapType.indexOf('x') === 0;
    }

    // The stage is the viewport minus whatever sits above it (the header).
    function measureTop() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--stage-top', Math.round(top) + 'px');
    }

    // The current frame is the one under the viewer's centre line: frames can
    // be taller than the viewer, so "mostly visible" never fires for them.
    function findCurrent() {
      var h = horizontal();
      var mid = h ? viewer.scrollLeft + viewer.clientWidth / 2 : viewer.scrollTop + viewer.clientHeight / 2;
      for (var i = 0; i < frames.length; i++) {
        var f = frames[i];
        var a = h ? f.offsetLeft : f.offsetTop;
        var b = a + (h ? f.offsetWidth : f.offsetHeight);
        if (mid >= a && mid < b) return i;
      }
      return mid < 0 ? 0 : frames.length - 1;
    }

    function atEnd() {
      return horizontal()
        ? viewer.scrollLeft + viewer.clientWidth >= viewer.scrollWidth - 2
        : viewer.scrollTop + viewer.clientHeight >= viewer.scrollHeight - 2;
    }

    function sync() {
      ticking = false;
      var i = findCurrent();
      if (hint) hint.hidden = atEnd() || i === frames.length - 1;
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, k) {
        if (k === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (countNow) countNow.textContent = String(i + 1);
      if (live) live.textContent = railLabel + ' ' + (i + 1) + ' / ' + frames.length;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    function goTo(i, smooth) {
      untouched = false;
      var f = frames[i];
      if (!f) return;
      var opts = { behavior: smooth && !reduced.matches ? 'smooth' : 'auto' };
      if (horizontal()) opts.left = f.offsetLeft - (viewer.clientWidth - f.offsetWidth) / 2;
      else opts.top = f.offsetTop;
      viewer.scrollTo(opts);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault(); // keep the hash out of the address bar
        goTo(i, true);
      });
      if (rail.dataset.hover === 'true') {
        t.addEventListener('mouseenter', function () { goTo(i, true); });
      }
    });

    // A frame is taller than the stage, so opened at the top the first
    // photograph loses its hem. Open with it centred instead (Shiva,
    // 2026-09-28), and keep it centred while nobody has scrolled.
    var untouched = true;
    function centreFirst() {
      if (!untouched || horizontal() || !frames[0]) return;
      var offset = Math.max(0, (frames[0].offsetHeight - viewer.clientHeight) / 2);
      viewer.scrollTo({ top: offset, behavior: 'auto' });
    }
    viewer.addEventListener('wheel', function () { untouched = false; }, { passive: true });
    viewer.addEventListener('touchstart', function () { untouched = false; }, { passive: true });
    viewer.addEventListener('keydown', function () { untouched = false; });

    viewer.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureTop(); centreFirst(); onScroll(); });
    measureTop();
    centreFirst();
    sync();

    // Theme editor: selecting a placeholder frame scrolls to it.
    document.addEventListener('shopify:block:select', function (e) {
      var i = frames.indexOf(e.target.closest && e.target.closest('[data-crf-frame]'));
      if (i > -1 && root.contains(e.target)) goTo(i, true);
    });
  }

  function boot() {
    document.querySelectorAll('.crf-pdp').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.crf-pdp');
    if (r) init(r);
  });
})();
